import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from "@babackapp/customer-ui/components/input-group";
import { Separator } from "@babackapp/customer-ui/components/separator";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { ArrowLeft } from "lucide-react";
import { motion } from "motion/react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { useAddressForm } from "../hooks/use-address-form";

export function ReturnWidgetAddressCheck() {
  const { form, onSubmit } = useAddressForm();

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Contact & Adresse</HeaderTitle>
        <HeaderDescription>
          Vérifiez vos informations postales et de contact afin de vous assurer
          du bon déroulement de votre retour.
        </HeaderDescription>
      </Header>

      <form onSubmit={onSubmit}>
        <motion.div
          initial={{ opacity: 0, x: 15 }}
          animate={{ opacity: 1, x: 0, transition: { delay: 0.1 } }}
          exit={{ opacity: 0, x: -15 }}
          transition={{ duration: 0.3 }}
          className="grid grid-cols-6 gap-2"
        >
          <Controller
            control={form.control}
            name="first_name"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-1 col-span-3">
                <InputGroupInput placeholder="Prénom" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Prénom</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="last_name"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-4 col-span-3">
                <InputGroupInput placeholder="Nom" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Nom de famille</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />

          <Separator className="col-span-6 my-4" />

          <Controller
            control={form.control}
            name="address1"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-1 col-span-3">
                <InputGroupInput placeholder="Numéro et rue" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Numéro et rue</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="address2"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-4 col-span-3">
                <InputGroupInput placeholder="Complément (optionnel)" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Complément d'adresse</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="city"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-1 col-span-2">
                <InputGroupInput placeholder="Ville" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Ville</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="zip"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-3 col-span-2">
                <InputGroupInput placeholder="Code postal" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Code postal</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="country_code"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-5 col-span-2">
                <InputGroupInput placeholder="Pays" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Pays</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />

          <Separator className="col-span-6 my-4" />

          <Controller
            control={form.control}
            name="email"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-1 col-span-3">
                <InputGroupInput placeholder="E-mail" type="email" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>E-mail</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
          <Controller
            control={form.control}
            name="phone"
            render={({ field }) => (
              <InputGroup className="h-auto col-start-4 col-span-3">
                <InputGroupInput placeholder="+33 6 00 00 00 00" type="tel" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>Téléphone</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            )}
          />
        </motion.div>

        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer
            layoutId="line-item-back-button"
            disableVariants={{ exit: true }}
          >
            <Link to="../return-mode">
              <Button variant="secondary" type="button">
                <ArrowLeft />
                Retour
              </Button>
            </Link>
          </AnimatedButtonContainer>
          <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
            <Button type="submit">
              <EnterIcon />
              Confirmer
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </form>
    </WidgetPage>
  );
}
